import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();
  const whatsappUrl = 'https://api.whatsapp.com/send/?phone=919022040062&text=Hello%20i-Sha%20Infosys';

  return (
    <footer className="site-footer">
      <div className="container footer-shell">
        <div className="footer-grid">
          <div className="footer-brand">
            <span className="footer-label">i-Sha Infosys</span>
            <h3>Technology setups that look modern, work reliably, and stay supported.</h3>
            <p>
              We help offices across Mira Road and Mumbai with networking, security, storage,
              repairs, and ongoing maintenance.
            </p>
          </div>

          <div className="footer-col">
            <h4>Navigate</h4>
            <Link to="/">Home</Link>
            <Link to="/services">Services</Link>
            <Link to="/contact">Contact</Link>
          </div>

          <div className="footer-col">
            <h4>Popular Services</h4>
            <Link to="/services/advanced-networking">Advanced Networking</Link>
            <Link to="/services/cctv-biometric">CCTV & Biometric</Link>
            <Link to="/services/nas-storage">NAS & Data Storage</Link>
            <Link to="/services/sales-amc">Annual Maintenance</Link>
          </div>

          <div className="footer-col">
            <h4>Reach Us</h4>
            <a href={whatsappUrl} target="_blank" rel="noreferrer">+91 90220 40062</a>
            <a href="mailto:Support@ishainfosys.com">Support@ishainfosys.com</a>
            <p>Mira Road East, Mumbai - 401107</p>
            <p>GSTIN: 27DFNPS5093L1ZH</p>
          </div>
        </div>

        <div className="footer-bottom">
          <span>Copyright {year} i-Sha Infosys</span>
          <span>Designed for fast deployment on Cloudflare Pages</span>
        </div>
      </div>
    </footer>
  );
}
